import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { Button, Form, Table } from "react-bootstrap";
import { FaLock, FaLockOpen, FaPlus, FaRegTrashAlt, FaTrashAlt } from "react-icons/fa";
import { NoDataFoundTable } from "../../../Hooks/NoDataFoundTable";
import UseToggle from "../../../Hooks/UseToggle";
import Pagination from "../../../Hooks/Pagination";
import AddSitePilotIntegration from "./AddSitePilotIntegration";
import Swal from "sweetalert2";
import DeletedSitePilotIntegration from "./DeletedSitePilotIntegration";
import UpdateSitePilotIntegration from "./UpdateSitePilotIntegration";
import SitePilotIntegrationPreview from "./SitePilotIntegrationPreview";
import Moment from "react-moment";
import { integrationServices } from "../../../APIServices/SitePilotManagement/integrationServices";
import SitePilotIntegrationActivity from "./SitePilotIntegrationActivity";

const SitePilotIntegration = () => {
  const toggles = UseToggle();
  
  const [searchData, setSearchData] = useState("");
  const [sitePilotIntegrationList, setSitePilotIntegrationList] = useState([]);
  const [sitePilotIntegrationCount, setSitePilotIntegrationCount] = useState(0);
  const [singleSitePilotIntegration, setSingleSitePilotIntegration] = useState("");
  
  const [deletedSitePilotIntegration, setDeletedSitePilotIntegration] = useState([]);
  const [deletedSitePilotIntegrationCount, setDeletedSitePilotIntegrationCount] = useState(0);
  
  const [sitePilotIntegrationdata, setSitePilotIntegrationdata] = useState("");
  const [openPreview, setOpenPreview] = useState(false);
  const [openModule, setOpenModule] = useState("preview");
  
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(sitePilotIntegrationCount / itemsPerPage);
  
  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);
  
  const tabs = [
    { key: "preview", label: "Preview" },
    ...(!singleSitePilotIntegration?.lockStatus
      ? [{ key: "sitePilotIntegrationEditor", label: "Integration Editor" }]
      : []),
    { key: "activity", label: "Activity" },
  ];
  
  const getSitePilotIntegrationList = async () => {
    let data = await integrationServices.getSitePilotIntegrationList(
      "all",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setSitePilotIntegrationList(data?.data || []);
    setSitePilotIntegrationCount(data?.count || 0);
  };

  const getDeletedSitePilotIntegrationList = async () => {
    let data = await integrationServices.getSitePilotIntegrationList(
      "deleted",
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedSitePilotIntegration(data?.data || []);
    setDeletedSitePilotIntegrationCount(data?.count || 0);
  };

  const softDeleteRestoreSitePilotIntegration = async (formId, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} blog post?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { formId, type };
      const data = await integrationServices.softDeleteRestoreSitePilotIntegration(userData);
      if (data?.statusCode === 200) {
        getSitePilotIntegrationList();
        getDeletedSitePilotIntegrationList();
      }
    });
  };

  const updatedLockSitePilotIntegration = async (integrationId, lockStatus) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${lockStatus ? "lock" : "unlock"} Integration?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { integrationId, lockType: true, lockStatus };
      const data = await integrationServices.updatedSitePilotIntegration(userData);
      if (data?.statusCode === 200) getSitePilotIntegrationList();
    });
  };

  useEffect(() => {
    getSitePilotIntegrationList();
  }, [searchData, pageNumber, itemsPerPage]);

  const getSingleSitePilotIntegration = async () => {
    let data = await integrationServices.getSingleSitePilotIntegration(sitePilotIntegrationdata?.integrationId);
    setSingleSitePilotIntegration(data?.data || "");
  };

  useEffect(() => {
    if (sitePilotIntegrationdata) {
      getSingleSitePilotIntegration()
    }
  }, [sitePilotIntegrationdata]);
  
  return (
    <>
    <div style={{ background: "#eee" }}>
      <div className="p-2 d-flex gap-2">
        <div className={`meta-table overflow-auto`} style={{ height: "calc(100vh - 71px)", flex: openPreview ? ".5 0 " : ""}}>
          <div className="hstack gap-2 pb-2 bg-white">
            <Button
              size="sm"
              variant="outline-primary"
              className="hstack gap-2 text-nowrap rounded-1 border"
              style={{ fontSize: 13 }}
              onClick={toggles.setToggle}
            >
              <FaPlus /> {!openPreview && "Add New"}
            </Button>
            <div className="search-box position-relative w-100">
              <FiSearch />
              <Form.Control
                type="search"
                className="w-100 rounded-1"
                style={{ fontSize: 13 }}
                placeholder="Search..."
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
              />
            </div>
            {deletedSitePilotIntegrationCount > 0 && (
              <Button
                variant="outline-danger"
                className="hstack gap-2 text-nowrap rounded-1 border"
                style={{ fontSize: 13 }}
                onClick={toggles.setToggle2}
              >
                <FaRegTrashAlt /> {!openPreview && "Deleted History"}
              </Button>
            )}
          </div>
          <div className="overflow-auto" style={{ height: "calc(100vh - 122px)"}}>
            {sitePilotIntegrationCount === 0 ? (
              <NoDataFoundTable MSG="No Integration." />
            ) : (
              <>
                <Table hover responsive className="">
                  <thead className="position-sticky" style={{ top: -1 }}>
                    <tr>
                      <th style={{ width: 45 }} className="text-center">
                        Sr.
                      </th>
                      <th style={{ width: 50 }}>Icon</th>
                      <th style={{ width: !openPreview && "30%" }}>Title</th>
                      {!openPreview && (
                        <>
                          <th>Updated By</th>
                          <th>Update Date | Time</th>
                          <th>Status</th>
                          <th>Integrate Status</th>
                          <th className="text-center">Lock</th>
                          <th className="text-center" style={{ width: 80 }}>
                            Actions
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {sitePilotIntegrationList?.map((item, index) => (
                      <tr
                        key={index}
                        className={
                          sitePilotIntegrationdata?.integrationId === item.integrationId ? "selectedRow CP" : "CP"
                        }
                        onClick={() => {
                          setOpenPreview(true);
                          setSitePilotIntegrationdata(item);
                        }}
                      >
                        <td className="text-center">{startIndex + index + 1}</td>
                        <td>
                          <img src={item?.icon} style={{height: 25}} />
                        </td>
                        <td className="text-truncate text-wrap" style={{ maxWidth: 100 }}>
                          <strong>{item?.title}</strong>
                          <div className="sub-text">
                            {item.subTitle}
                          </div>
                        </td>
                        {!openPreview && (
                          <>
                            <td>{item.updatedByName}</td>
                            <td><Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                              {item?.updatedAt}
                            </Moment></td>
                            <td className={`text-capitalize fw-bold ${item.status === "active" ? "text-success" : item.status === "inactive" ? "text-danger" : "text-muted"}`}>{item.status}</td>
                            <td className={`text-capitalize fw-bold ${item.type === "published" ? "text-success" : "text-muted"}`}>{item.type === "comingSoon" ? "Coming Soon" : "Published"}</td>
                            <td
                              className="text-center CP"
                              title="Lock Status"
                              onClick={(e) => {
                                e.stopPropagation();
                                updatedLockSitePilotIntegration(item.integrationId, !item.lockStatus);
                              }}
                            >
                              {item.lockStatus ? (
                                <FaLock className="text-success" />
                              ) : (
                                <FaLockOpen className="text-danger" />
                              )}
                            </td>
                            <td className="text-center actions">
                              <FaTrashAlt
                                title="Delete"
                                onClick={(e) => {e.stopPropagation();
                                if (!item.lockStatus) {
                                    softDeleteRestoreSitePilotIntegration(
                                      item.integrationId,
                                      "delete"
                                    );
                                  }} }
                                className={`icon danger CP ${item.lockStatus ? "disabled" : ""}`}
                              />
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={sitePilotIntegrationCount?.totalItems}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {openPreview && (
          <div className="meta-preview" style={{ flex: "1.5 0" }}>
            <div className="preview-header hstack justify-content-between">
              <div className="hstack gap-2">
                {tabs.map((tab) => (
                  <Button
                    key={tab.key}
                    size="sm"
                    style={{ fontSize: 13 }}
                    variant={
                      openModule === tab.key ? "primary" : "outline-primary"
                    }
                    onClick={() => setOpenModule(tab.key)}
                  >
                    {tab.label}
                  </Button>
                ))}
              </div>
              <Button
                size="sm"
                style={{ fontSize: 13 }}
                variant="outline-danger"
                onClick={() => setOpenPreview(false)}
              >
                Close
              </Button>
            </div>
            {openModule === "preview" && (
              <div
                className="overflow-auto"
                style={{ height: "calc(100vh - 123px)" }}
              >
              <div className="w-50 m-auto">
                <SitePilotIntegrationPreview singleSitePilotIntegration={singleSitePilotIntegration}/>
              </div>
              </div>
            )}
            {openModule === "sitePilotIntegrationEditor" && (
              <UpdateSitePilotIntegration
                singleSitePilotIntegration={singleSitePilotIntegration}
                getSitePilotIntegrationList={getSitePilotIntegrationList}
                getSingleSitePilotIntegration={getSingleSitePilotIntegration}
              />
            )}
            {openModule === "activity" && <SitePilotIntegrationActivity />}
          </div>
        )}
      </div>
    </div>
    <AddSitePilotIntegration
      Show={!toggles?.toggle}
      Hide={toggles?.setToggle}
      Title={`Add New Integration`}
      getSitePilotIntegrationList={getSitePilotIntegrationList}
      />

      <DeletedSitePilotIntegration
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title={`Restore Mail Integrations`}
        deletedSitePilotIntegration={deletedSitePilotIntegration}
        softDeleteRestoreSitePilotIntegration={softDeleteRestoreSitePilotIntegration}
        deletedSitePilotIntegrationCount={deletedSitePilotIntegrationCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        getDeletedSitePilotIntegrationList={getDeletedSitePilotIntegrationList}
      />
    </>
  );
};

export default SitePilotIntegration;
